export * from './url';

// For dev / test use
export const DEFAULT_CLASSROOM_ID = '1a90e78d-85e5-4f21-8c17-e9d1c07002be';

export const ASSIGNMENT_SUBMISSION_STATES = {
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  SUBMITTED: 'SUBMITTED',
  LATE: 'LATE',
  AUTO_GRADING: 'AUTO_GRADING',
  AUTO_GRADED: 'AUTO_GRADED',
  AUTO_GRADED_WARNING: 'AUTO_GRADED_WARNING',
  GRADED: 'GRADED',
  RETURNED: 'RETURNED',
};

export const ASSIGNMENT_STATES = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const APPNAME = 'academix'
